import {Table, Tag} from "antd";
import moment from "moment";
import React from "react";

const processMapping = {
    // First Mile (FM) Processes
    CREATED: "Oluşturuldu",
    PICKED_UP: "Teslim Alındı",

    // General (G) Processes
    TRANSFER_PLANNED: "Transfer Planlandı",
    RETURNED_TO_WAREHOUSE: "Depoya İade Edildi",

    // First Mile, Mid Mile, Last Mile (FM|MM|LM) Processes
    TRANSFER_ASSIGNED: "Transfer Zimmete Alındı",
    TRANSFER_UNASSIGNED: "Transfer Zimmetten Çıkarıldı",
    TRANSFER_DEPARTED: "Transfer Yola Çıktı",
    TRANSFER_DELIVERED_TO_WAREHOUSE: "Transfer Depoya Bırakıldı",
    WAREHOUSE_ASSIGNED: "Depo Zimmete Alındı",

    // Last Mile (LM) Processes
    DEPARTED_TO_CUSTOMER: "Müşteriye Yola Çıktı",
    DELIVERED_TO_CUSTOMER: "Müşteriye Teslim Edildi",
    DELIVERY_FAILED: "Müşteriye Teslim Edilemedi",
    SCHEDULED_FOR_NEXT_DAY: "Sonraki Güne Sevk Bildirildi",
    RETURN_TO_WAREHOUSE_REPORTED: "Depoya İade Bildirildi",
    TRANSFER_COMPLETED: "Transfer Tamamlandı",

    // Missing Processes
    MISSING_REPORTED: "Kayıp Bildirildi",
    MISSING_REJECTED: "Kayıp Reddedildi",
    MISSING_APPROVED: "Kayıp Onaylandı",

    // Ekranda görünen diğer değerler
    TRANSFER_ZIMMETE_ALINDI: "Transfer Zimmete Alındı",
    MUSTERIYE_TESLIM_EDILDI: "Müşteriye Teslim Edildi",
    MUSTERIYE_YOLA_CIKTI: "Müşteriye Yola Çıktı",
    DEPO_ZIMMETE_ALINDI: "Depo Zimmete Alındı",
    TRANSFER_TAMAMLANDI: "Transfer Tamamlandı",
    SHIPMENT_MOVED_TO_NEW_TRANSFER: "Sevkiyat Yeni Transfere Aktarıldı",
    SHIPMENT_MOVED: "Sevkiyat Aktarıldı",

    // Undelivered Shipment Processes
    UN_DELIVERED_CREATED: "Teslim Edilemeyen Paket Oluşturuldu",
    UN_DELIVERED_ASSIGNED: "Teslim Edilemeyen Paket Zimmete Alındı",
    RETURN_ADDED: "Depo İade Eklendi",
    RETURN_COMPLETED: "Depo İade Tamamlandı",
    WAREHOUSE_REMOVED: "Depo Zimmetten Çıkarıldı"
};

const formatProcess = process => {
    // Mapping'de varsa formatlanmış değeri döndür
    if (processMapping[process]) {
        return processMapping[process];
    }

    // Mapping'de yoksa, underscore'ları boşluklara çevir ve her kelimenin ilk harfini büyük yap
    return process
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};

const ShipmentActivity = ({shipmentActivities}) => {
    return (
        <>
            <h3>Aktivite Listesi</h3>
            <Table dataSource={shipmentActivities}>
                <Table.Column
                    title="Oluşturulma Tarihi"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => moment(createdAt).format("DD-MM-YYYY HH:mm")}
                />
                <Table.Column
                    title="Depo"
                    dataIndex="transferCenter"
                    key="transferCenter"
                    render={transferCenter => (transferCenter ? transferCenter : "-")}
                />
                <Table.Column
                    title="İşlemi Yapan"
                    dataIndex="createdBy"
                    key="createdBy"
                    render={createdBy => (createdBy ? createdBy?.name : "-")}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="count"
                    key="count"
                    render={count => (count ? count + " Paket" : "-")}
                />
                <Table.Column
                    title="Transfer Tipi"
                    dataIndex="processType"
                    key="processType"
                    render={processType =>
                        processType !== "general" ? processType : "Planlama" || "-"
                    }
                />
                <Table.Column
                    title="İşlem"
                    dataIndex="process"
                    key="process"
                    render={process => (process ? formatProcess(process) : "-")}
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    render={(_, record) => {
                        const missingShipment = record?.meta?.missingShipmentId;
                        const unDeliveredShipment = record?.meta?.unDeliveredId;

                        const statusConfig = {
                            resolved: {color: "green", text: "Onaylandı"},
                            rejected: {color: "red", text: "Reddedildi"},
                            pending: {color: "orange", text: "Beklemede"},
                            default: {color: "blue", text: "Oluşturuldu"},
                            created: {color: "blue", text: "Oluşturuldu"},
                            completed: {color: "green", text: "Tamamlandı"},
                            cancelled: {color: "red", text: "İptal Edildi"}
                        };

                        if (missingShipment) {
                            const {color, text} =
                                statusConfig[missingShipment.status] || statusConfig.default;
                            return <Tag color={color}>{text}</Tag>;
                        }

                        if (unDeliveredShipment) {
                            const {color, text} =
                                statusConfig[unDeliveredShipment.status] || statusConfig.default;
                            return <Tag color={color}>{text}</Tag>;
                        }

                        return <Tag color="blue">Oluşturuldu</Tag>;
                    }}
                />
                <Table.Column
                    title="Detay"
                    dataIndex="detail"
                    key="detail"
                    render={(_, record) => {
                        const missingShipment = record?.meta?.missingShipmentId;
                        const unDeliveredShipment = record?.meta?.unDeliveredId;
                        const deliveredTo = record?.meta?.deliveredTo;
                        if (missingShipment) {
                            const detailConfig = {
                                resolved: missingShipment.resolvedReason,
                                rejected: missingShipment.rejectedReason,
                                pending: <Tag color="orange">Beklemede</Tag>
                            };

                            return detailConfig[missingShipment.status] || "";
                        }

                        if (unDeliveredShipment) {
                            return unDeliveredShipment?.reason?.label || "";
                        }

                        if (deliveredTo){
                            return deliveredTo;
                        }

                        return "";
                    }}
                />
            </Table>
        </>
    );
};

export default ShipmentActivity;
